import React from 'react';
import pluralize from 'pluralize';
import { ListGroup } from 'react-bootstrap-5';
import EmptyState from 'shared/empty_state';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { NonBasicCardStyling } from './util';

type CompanyDetails = {
  companyName: string,
  numberOfLeads: number
}
export type Props = {
  leadCountByCompanyName: CompanyDetails[]
}

export default function CompanyCard({ leadCountByCompanyName }: Props) {
  const totalLeads = leadCountByCompanyName.reduce((sum, c) => sum + c.numberOfLeads, 0);

  function contentForCard() {
    return (
      <>
        <div>
          {pluralize('Employee', totalLeads)} of {' '}
          <b>
            {leadCountByCompanyName.length} {pluralize('company', leadCountByCompanyName.length)}
          </b>{' '}
          have inquired about this listing.
        </div>
        <div className="overflow-scroll" style={{ maxHeight: '300px' }}>
          <ListGroup>
            {leadCountByCompanyName.map(companyDetails => (
              <ListGroup.Item
                className="d-flex justify-content-between align-items-center"
                key={companyDetails.companyName}
              >
                <b>{companyDetails.companyName}</b>
                <div className="ds-text-muted">
                  {companyDetails.numberOfLeads} {pluralize('Lead', companyDetails.numberOfLeads)}
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </>
    );
  }

  return (
    <div className={NonBasicCardStyling}>
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-normal">Companies</h6>
      </div>
      {leadCountByCompanyName.length > 0 ? contentForCard() :
        (
          <EmptyState
            bodyText="Waiting For Data..."
            header="No Companies to display"
            icon={faExclamationCircle}
            style={{ minHeight: '250px' }}
          />
        )
      }
    </div>
  );
}
